<template>
  <div class="bg-gray">
    <navigation-bar :mode="'Admin'"></navigation-bar>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12" style="padding-top:20px;">
            <div class="row">
              <div class="col-xs-12 col-sm-12 text-left">
                <div class="row">
                  <div class="col-sm-12">
                    <h1 style="float:left;">Users</h1>
                  </div>
                </div>
                <!-- Content -->
                <div class="row">
                  <div class="col-sm-12">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Newsletter</th>
                          <th class="hidden-sm">Last Login</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="user in store.state.users" :key="user.id">
                          <td>{{user.id}}</td>
                          <td>{{user.first_name}} {{user.last_name}}</td>
                          <td>{{user.email}}</td>
                          <td>{{user.newsletter}}</td>
                          <td class="hidden-sm">{{formatDate(user.lastLogin)}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <br>
        </div>
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from '../nav/NavigationBar.vue'
import DashboardFooter from '../nav/Footer'
import Utils from '@/Utils/Utils'
import Navigator from '@/router/navigator'
import AdminUsersStore from './AdminUsersStore'
import AdminPermissionsUtils from './AdminPermissionsUtils'
import moment from 'moment'

export default {
  name: 'AdminUsers',
  components: {
    NavigationBar,
    DashboardFooter
  },
  data () {
    return {
      nav: Navigator,
      store: AdminUsersStore,
      adminUtils: AdminPermissionsUtils
    }
  },
  mounted () {
    this.adminUtils.authorize((userId) => {
      this.store.state.currentUserId = userId;
      this.getUsers();
    },(err) => {
      this.$toasted.show(err, { type: 'error', duration: 2500 })
    })
  },
  methods: {
    getUsers: function () {
      this.store.getUsers((data)=>{
        
        this.$forceUpdate();
      },(err)=>{
        
        this.$toasted.show(err, { type: 'error', duration: 2500 })
      })
    },
    formatDate(date){
      if(!date){
        return "";
      }
      return moment(date).format("MM/DD/YYYY");
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/AdminUsers.vue